/**
 * Form类功能
 * 1.存储数据
 * 2.数据交互
 * 3.数据状态判断
 * 3.创建合适的数据结构传给后端
 */

// Check类是一个容器，配合装饰器使用，装饰器将判断函数存储在Check类里集中管理
class Check {
  checkMap: Map<string, (() => true | Error)[]> = new Map()

  check(context: Form, keys: string[]): true | Error
  check(context: Form): true | Error
  check(context: Form, args?: unknown): true | Error {
    if (Array.isArray(args)) {
      args.forEach((arg) => {
        const fns = this.checkMap.get(arg)
        if (fns) {
          fns.forEach((fn) => fn.call(context))
        }
      })
      return true
    } else {
      this.checkMap.forEach((fns) => fns.forEach((fn) => fn.call(context)))
      return true
    }
  }

  appendRule(key: string, fn: () => true | Error) {
    const fns = this.checkMap.get(key)
    if (fns) {
      fns.push(fn)
    } else {
      this.checkMap.set(key, [fn])
    }
  }
}

// 装饰器类，专门用于给Form类的原型的checker注入判断函数
export class Register {
  private static register(target: Form) {
    target.checker = new Check()
  }

  static registerRule(key: string) {
    return function (target: Form, methodName: string) {
      if (!target.hasOwnProperty.call(target, 'checker')) {
        Register.register(target)
      }
      ;(target.checker as Check).appendRule(key, target[methodName as keyof Form] as () => true | Error)
    }
  }
}

export abstract class Form {
  checker: Check | null = null
  private __proto__: any

  //1.存储数据
  constructor() {
    //如果使用装饰器注入了判断函数，那么就可以使用checker来集中管理判断
    let proto = this.__proto__
    if (proto.checker) this.checker = new Check()
    while (proto.checker) {
      if (proto.hasOwnProperty.call(proto, 'checker')) {
        ;(proto.checker.checkMap as Map<string, (() => true | Error)[]>).forEach((value, key) => {
          value.forEach((fn) => this.checker!.appendRule(key, fn))
        })
      }
      proto = proto.__proto__
    }
  }

  //3.数据状态判断
  check(keys: string[]): true | Error
  check(): true | Error
  check(args?: unknown): true | Error | void {
    if (!this.checker) return
    return this.checker.check(this, args as any)
  }

  //4.创建合适的数据结构传给后端
  abstract buildForm(): any
}
